module.exports = __webpack_public_path__ + "media/add/wheel-add-01-7ff0aa53.png";